import initialState from "./initialState";

const blogReducer = (state = initialState, action) => {
    switch (action.type) {
        default:
            return state;
    }
};

export default blogReducer;
